import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Tables } from "@/integrations/supabase/types";
import { format } from "date-fns";

type Lead = Tables<"leads">;

export const SeveranceInformation = ({ lead }: { lead: Lead }) => (
  <Card className="mb-6">
    <CardHeader>
      <CardTitle>Severance Information</CardTitle>
    </CardHeader>
    <CardContent className="space-y-2">
      <div>
        <div className="font-medium">Severance Status</div>
        <div className="capitalize">
          {lead.severance_status?.replace(/_/g, " ") || "Not specified"}
        </div>
      </div>
      <div>
        <div className="font-medium">Severance Deadline</div>
        <div>
          {lead.severance_deadline
            ? format(new Date(lead.severance_deadline), "MMMM d, yyyy")
            : "Not specified"}
        </div>
      </div>
    </CardContent>
  </Card>
);